module.exports = __webpack_public_path__ + "img/formusicfan.2093a675.png";